import React from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import './style.scss';

function DragableList (props) {

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
          return;
        }

        const items = reorder(
            props.list,
            result.source.index,
            result.destination.index
        );

        props.setList(items);
    }

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
      
        return result;
    };

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: "none",
        padding: 10,
        ...draggableStyle
    });

  return <ul>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                {(provided) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                    >
                    {props.list.map((item, index) => (
                        <Draggable key={item.column} draggableId={item.column} index={index}>
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}
                                    onClick={() => {
                                        props.setSelectedItem(item);
                                    }}
                                    className={(props.selectedItem && props.selectedItem.column === item.column) ? 'select-column' : ''}
                                >
                                {item.name}
                                </div>
                            )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                    </div>
                )}
                </Droppable>
            </DragDropContext>
        </ul>
}

export default DragableList;
